export default __webpack_public_path__ + "static/media/close-icon.9a592a76.svg";